<template>
  <div
    class="min-height dashboard-screen-container inputcontainer theme--light s"
  >
    <CRow>
      <CCol sm="6" class="d-align">
        <h3 class="m-0">Subscription</h3>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol sm="6" class="datepicker pos-r">
            <label for>Date Range</label>
            <div class="datepicker pos-r">
              <datepicker
                v-model="dateRange"
                @input="dateChange()"
                ref="datepicker"
                :model-config="datePickerConfig"
                :max-date="new Date()"
                is-range
                :masks="{ input: 'DD/MM/YYYY' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="
                      !!inputValue.start && !!inputValue.end
                        ? inputValue.start + ' - ' + inputValue.end
                        : 'Select Date Range'
                    "
                    v-on="inputEvents.start"
                    class="form-control pos-r"
                    placeholder="Select Date Range"
                  />
                  <div
                    v-if="!!inputValue.start && !!inputValue.end"
                    class="cross-svg subscription-cross-svg"
                    @click="resetJoiningDate"
                  >
                    <crossSVG />
                  </div>
                </template>
              </datepicker>
              <div class="calendarsvg pos-a">
                <calendarSVG />
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <!-- ........................................................... -->
    <CRow>
      <CCol sm="12">
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          class="border-bottom border-top"
        >
          <v-tab v-for="(item, i) in items" :key="i">{{ item.tabName }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <!-- Doctor -->
          <v-tab-item>
            <subscription-dashboard-card
              :date="dateRange"
              :role="'doctor'"
              v-if="tabs == 0"
            />
          </v-tab-item>
          <!-- Pharmacy -->
          <v-tab-item>
            <subscription-dashboard-card
              :date="dateRange"
              :role="'pharmacy'"
              v-if="tabs == 1"
            />
          </v-tab-item>
          <!-- Diagnostic -->
          <v-tab-item>
            <subscription-dashboard-card
              :date="dateRange"
              :role="'diagnostics-lab'"
              v-if="tabs == 2"
            />
          </v-tab-item>
          <!-- Bloodbank -->
          <v-tab-item>
            <subscription-dashboard-card
              :date="dateRange"
              :role="'bloodbank'"
              v-if="tabs == 3"
            />
          </v-tab-item>
          <!-- Ambulance -->
          <v-tab-item>
            <subscription-dashboard-card
              :date="dateRange"
              :role="'ambulance'"
              v-if="tabs == 4"
            />
          </v-tab-item>
        </v-tabs-items>
      </CCol>
    </CRow>
  </div>
</template>
<script>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
const Image = () => import("@/components/image.vue");
const subscriptionDashboardCard = () =>
  import("@/views/dashboardList/subscriptionDashboardCard");
export default {
  components: {
    Datepicker,
    ...pickSvg("crossSVG", "searchSVG"),
    "image-view": Image,
    "subscription-dashboard-card": subscriptionDashboardCard,
  },
  data() {
    return {
      search: "",
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dateRange: {
        start: "",
        end: "",
      },
      tabs: null,
      items: [
        { tabName: "Doctor" },
        { tabName: "Pharmacy" },
        { tabName: "Diagnostics" },
        { tabName: "Bloodbank" },
        { tabName: "Ambulance" },
      ],
    };
  },
  methods: {
    dateChange() {
      // this.getBlogList();
    },
    clearSearch() {
      this.search = "";
    },
    resetJoiningDate() {
      this.dateRange = { start: "", end: "" };
    },
  },
};
</script>